var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as profileActions from '../actions/profile';
var initialState = {
  changingPassword: false,
  changePasswordSuccess: false
};
export default function (state, action) {
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case profileActions.PROFILE_PASSWORD_SAVING:
      return __assign(__assign({}, state), {
        changingPassword: true,
        changePasswordError: null,
        changePasswordSuccess: false
      });
    case profileActions.PROFILE_PASSWORD_SAVE_SUCCESS:
      return __assign(__assign({}, state), {
        changingPassword: false,
        changePasswordError: null,
        changePasswordSuccess: true
      });
    case profileActions.PROFILE_PASSWORD_SAVE_FAILURE:
      return __assign(__assign({}, state), {
        changingPassword: false,
        changePasswordError: action.error,
        changePasswordSuccess: false
      });
  }
  return state;
}